import { TriangleAlert } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../hooks";

interface Props {
    subscriptionStatus: "expired" | "unsubscribed"
}

const PlanSelectionNoticeModal : React.FC<Props> = ({ subscriptionStatus }) => {

    const navigate = useNavigate();
    // const userDetails = useAppSelector((state) => state.auth.user);
    // const userRole = userDetails?.main_role;
    const authDetails = useAppSelector((state) => state.auth);


    return ( 
        <div className="modal">
            <div className="modal-body p-4 flex flex-col items-center text-center gap-4">
                <TriangleAlert size={64} color="red"/>
                <h1 className="text-2xl font-semibold text-primary">
                    {subscriptionStatus == "expired" && ("Your current plan has expired. Let's get you a new package")}
                    {subscriptionStatus == "unsubscribed" && ("You have no active plans. Let's get you a package")}
                </h1>
                {authDetails.activeRole == "Admin" ? (
                    <button 
                        className="form-btn mt-4"
                        onClick={() => navigate("/plans")}
                    >
                        Go to Plans
                    </button>
                ) : (
                    <p className="text-lg mt-4">
                        Contact your Business Admin to purchase a new subscription
                    </p>
                )}
            </div>
        </div>
     );
}
 
export default PlanSelectionNoticeModal;